import { Box, Typography, Collapse } from '@mui/material';

import { ConverserValidatorEventProps, Message, Part } from '../types';

const getTextPartContent = (message: Message) => {
    return (
        message?.parts?.find((p: Part) => p.part_kind === 'text')?.content ||
        message?.parts?.find((p: Part) => p.part_kind === 'retry-prompt')?.content ||
        message?.content ||
        ''
    );
};

const ConverserValidatorEvent = ({ responseMessage, triggerMessage, isExpanded }: ConverserValidatorEventProps) => {
    const sections = [
        {
            title: 'LLM Response Failure',
            content: getTextPartContent(responseMessage),
        },
        {
            title: 'Validator Feedback',
            content: getTextPartContent(triggerMessage),
        },
    ];

    return (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ mt: 1 }}>
                {sections.map(({ title, content }) => (
                    <Box key={title}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                            {title}
                        </Typography>
                        <Typography
                            variant="body2"
                            component="div"
                            sx={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                backgroundColor: '#f5f5f5',
                                p: 1.5,
                                borderRadius: 1,
                                mb: 2,
                            }}
                        >
                            {content}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Collapse>
    );
};

export default ConverserValidatorEvent;
